import React from "react";
import StellaLogo from "./StellaLogo";
import { Sparkles } from "lucide-react";

const SUGGESTIONS = [
  { title: "Synthesize a strategic memo", subtitle: "Executive summary with risks and next steps" },
  { title: "Analyze a competitor's pricing", subtitle: "Positioning, gaps, and a 3-option response" },
  { title: "Draft a partnership email", subtitle: "Warm, direct, no fluff — draft only" },
  { title: "Verdict-first code review", subtitle: "Route to Developer/Security specialist" },
  { title: "Plan a two-week travel schedule", subtitle: "Concise itinerary with contingencies" },
  { title: "Explain a legal concept plainly", subtitle: "Jurisdiction caveats included" },
];

export default function EmptyState({ userName = "Giorgio", onPick }) {
  const hour = new Date().getHours();
  const greeting = hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";
  return (
    <div className="w-full max-w-3xl mx-auto px-5 py-10 sm:py-16 flex flex-col items-start">
      <div className="mb-6 flex items-center gap-3 text-indigo-700">
        <StellaLogo className="w-8 h-8" withGlow />
        <span className="text-xs uppercase tracking-[0.24em] text-slate-500 font-semibold">Stella</span>
      </div>
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900" data-testid="empty-state-greeting">
        {greeting}, {userName}.
      </h1>
      <p className="mt-3 text-base sm:text-lg text-slate-500 max-w-xl">
        What shall we achieve today? Pick a prompt below or type your own.
      </p>
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3 w-full">
        {SUGGESTIONS.map((s, i) => (
          <button
            key={i}
            onClick={() => onPick?.(s.title)}
            data-testid={`suggested-prompt-${i}`}
            className="group text-left bg-white border border-[#E5E4DE] rounded-2xl px-4 py-3 hover:border-indigo-300 hover:shadow-[0_2px_12px_rgba(67,56,202,0.08)] transition-colors duration-150"
          >
            <div className="flex items-center gap-2 text-slate-900 font-semibold text-sm sm:text-base">
              <Sparkles className="w-4 h-4 text-indigo-500 shrink-0" />
              <span>{s.title}</span>
            </div>
            <div className="mt-1 text-xs sm:text-sm text-slate-500">{s.subtitle}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
